<script setup lang="ts">
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import type { ItemsPerPageOptions } from '~/composables/paginated-project-list';
import { savedItemsPerPage } from '~/composables/paginated-project-list';
import CaretDown from '~icons/carbon/caret-down';
import IconCheck from '~icons/ph/check-bold';

const options: ItemsPerPageOptions[] = [10, 20, 50, 100];

async function selectItemsPerPage(option: ItemsPerPageOptions) {
  savedItemsPerPage.value = option;
}
</script>

<template>
  <div class="flex items-center gap-2">
    <Menu as="div" class="three-dot-menu">
      <MenuButton as="button" class="menu-btn-trigger">
        {{ savedItemsPerPage }} <CaretDown class="ml-0.5" />
      </MenuButton>

      <Transition name="animate-menu-panel">
        <MenuItems class="three-dot-menu__panel --right mt-1 min-w-[5rem] px-0.5">
          <MenuItem
            v-for="option in options"
            :key="option"
            as="button"
            class="three-dot-menu__item-btn gap-1 text-sm"
            @click="selectItemsPerPage(option)"
          >
            <IconCheck
              class="text-xs"
              :aria-hidden="option === savedItemsPerPage"
              :class="[option === savedItemsPerPage ? '' : 'opacity-0']"
            />

            {{ option }}
          </MenuItem>
        </MenuItems>
      </Transition>
    </Menu>

    <span class="text-xs max-sm:hidden">Items per page</span>
  </div>
</template>

<style scoped lang="postcss">
.menu-btn-trigger {
  @apply relative inline-flex items-center rounded border bg-white px-2 py-1 text-xs hover:bg-new-gray-50 dark:bg-gray-675;
  @apply outline-none focus-visible:outline-offset-0 focus-visible:ring-1 focus-visible:ring-inset;
  @apply dark:border-new-gray-950/80;

  &.--selected {
    @apply cursor-default bg-new-green-300 dark:bg-new-green-700 dark:text-new-content-900;
  }
}
</style>
